import { t } from "@lingui/macro";
import { useAtomValue, useSetAtom } from "jotai";

import { PatronsListItem } from "@/features/AddPatrons/components/PatronsListItem";

import { enterEditableRoundsPrivateStepAtom } from "../../../../atoms/actions/EnterEditableRoundsPrivateStepAtom/enterEditableRoundsPrivateStepAtom";
import { replacePlayerOnRoundAtom } from "../../../../atoms/actions/replacePlayerOnRoundAtom/replacePlayerOnRoundAtom";
import { currentBookingAtom } from "../../../../atoms/stores";
import { PatronEditBooking } from "../../../../types";

export const MemberHoldPlayer = ({
  replacingRound,
}: {
  replacingRound: PatronEditBooking.Round | null | undefined;
}) => {
  const currentBooking = useAtomValue(currentBookingAtom);
  const replacePlayerOnRound = useSetAtom(replacePlayerOnRoundAtom);
  const enterEditableRoundsPrivateStep = useSetAtom(
    enterEditableRoundsPrivateStepAtom
  );
  return currentBooking?.canAddMemberHold &&
    replacingRound?.player.clientType !== "memberHold" ? (
    <PatronsListItem
      item={{ type: "Member Hold", memberGroups: [] }}
      displayName={t`Member Hold`}
      selectionAction="replace"
      handleCheck={() => {
        replacePlayerOnRound({
          roundId: replacingRound?.localId ?? "",
          player: {
            clientType: "memberHold",
            id: null,
            firstName: null,
            lastName: null,
          },
        });
        enterEditableRoundsPrivateStep();
      }}
    />
  ) : null;
};
